export default __webpack_public_path__ + "static/media/rewards_icon_adventure.c3232a7e.svg";